module.exports = __webpack_public_path__ + "img/c1.2fc002d7.png";